import { render } from "./IconQuestion.vue?vue&type=template&id=4d6a074e"
import script from "./IconQuestion.vue?vue&type=script&lang=js"
export * from "./IconQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__